import { useIntersectionObserver } from '@vueuse/core';
import { shallowRef } from 'vue';

/** Label value to set for the picture's ref attribute. */
export const lazyImageLabel = '_el';

/**
 * Dynamically set the srcset attribute when in the viewport.
 *
 * This prevents the browser's prerender crawler from starting
 * to fetch images outside the viewport.
 *
 * Make sure to add :ref="label" to the picture tag.
 * Even if not used, you need to extract the '_el' return,
 * this lets Vue hook up the template ref.
 */
export function useLazyImage(lazy: boolean) {
	const isVisible = shallowRef(!lazy);
	const _el = shallowRef<HTMLPictureElement | null>(null);

	const { stop } = useIntersectionObserver(
		isVisible.value ? null : _el,
		([entry]) => {
			if (entry?.isIntersecting) isVisible.value = true;
			if (isVisible.value) stop();
		},
		{ rootMargin: '200px' }
	);

	return { _el, isVisible };
}
